jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.centered-image-slider').length ) {
        let $ = jQuery;

        $(".centered-image-slider .image-slider").each(function() {
            $(this).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '100px',
                rows: 0,
                dots: false,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 7000,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '100px',
                        }
                    }
                ]
            });
        });

    }
});